import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AppDataProvider } from './contexts/AppDataContext';
import { AppLayout } from './components/layout/AppLayout';
import { Home } from './pages/Home';
import { Habits } from './pages/Habits';
import { Tasks } from './pages/Tasks';
import { BorrowedItems } from './pages/BorrowedItems';
export function App() {
  return <AppDataProvider data-id="element-0" data-mp="2rkdy0w5h7fot">
      <BrowserRouter data-id="element-1" data-mp="2rlyoa9krccgv">
        <Routes data-id="element-2" data-mp="2rl6vf6ijosua">
          <Route element={<AppLayout data-id="element-4" data-mp="2mluboumz01vx" />} data-id="element-3" data-mp="2riko97zkgfcl">
            <Route path="/" element={<Home data-id="element-6" data-mp="2mndq0fp2g2v2" />} data-id="element-5" data-mp="2mmluf4vgy54s" />
            <Route path="/habits" element={<Habits data-id="element-8" data-mp="31agp2qt1ejki" />} data-id="element-7" data-mp="2mjpwvhnj9igv" />
            <Route path="/tasks" element={<Tasks data-id="element-10" data-mp="31c1ha9rvpqf7" />} data-id="element-9" data-mp="31bs1ff0jszn8" />
            <Route path="/borrowed" element={<BorrowedItems data-id="element-12" data-mp="2wjqhd6x524mn" />} data-id="element-11" data-mp="31cjk5p91r2w3" />
          </Route>
        </Routes>
      </BrowserRouter>
    </AppDataProvider>;
}